import React, { useState, useMemo, useRef } from "react";
import { XIcon } from "@heroicons/react/outline";
import Draggable from "react-draggable";
import { Modal } from "react-bootstrap";

export default function ModalItemComponent({
  component,
  headerIcon,
  modalHeader,
  componentProps,
  modalSubHeader,
  pathIllustration = "",
  hideHeader = false,
  showCloseIcon = true,
  onCloseIconClick,
  showDivider = false
}) {
  const [currentRotate, setCurrentRotate] = useState(0);
  const [open, setOpen] = useState(true);
  const isDraggingRef = useRef(false);

  const isDarkPage = useMemo(() => {
    if (
      window.location.pathname.includes("/trade") &&
      !window.location.pathname.includes("/configuracoes-trade")
    ) {
      return true;
    }
    return false;
  }, [window.location.pathname]);

  const onDrag = () => {
    isDraggingRef.current = true;
  };

  const onStop = () => {
    if (!isDraggingRef.current) {
      setCurrentRotate(currentRotate + 90);
    }
    isDraggingRef.current = false;
  };

  return (
    <div
      className={`${!open ? "hidden" : "-mr-2"} relative z-[99999999]`}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`fixed inset-0 ${
          !isDarkPage ? "bg-gray-500" : "bg-neutral-900/80"
        } bg-opacity-75 transition-opacity duration-200`}
      />
      <div className="fixed inset-0 overflow-hidden">
        <div className="flex items-end sm:items-center justify-center min-h-full p-6 text-center sm:p-0">
          <Draggable onStop={onStop} onDrag={onDrag}>
            <div
              className={`flex justify-start items-start gap-6 relative ${
                !isDarkPage
                  ? "bg-white"
                  : "bg-neutral-900 border border-neutral-800"
              } rounded-lg px-4 pt-2 pb-4 text-left shadow-xl sm:my-0.5 sm:p-6 sm:pb-0.5 min-w-[27.25rem] 2xl:min-w-[31.25rem]`}
            >
              {pathIllustration.trim().length > 0 && (
                <div className="h-full flex items-start justify-center w-[60px]">
                  <img src={pathIllustration} alt="ilustração" />
                </div>
              )}
              <div className="flex flex-col items-start justify-start w-full h-full">
                {!hideHeader && (
                  <Modal.Header className="mb-4 cursor-move w-full drag-handle">
                    <Modal.Title id="example-modal-sizes-title-lg">
                      <div>
                        {headerIcon}
                        <div className="flex flex-col items-start justify-start gap-1">
                          <div
                            className={`${
                              !isDarkPage ? "text-neutral-800" : "text-white"
                            } text-lg font-medium`}
                          >
                            {modalHeader}
                          </div>
                          <div
                            className={`${
                              !isDarkPage
                                ? "text-neutral-500"
                                : "text-neutral-400"
                            } text-sm font-medium`}
                          >
                            {modalSubHeader}
                          </div>
                        </div>
                        {showCloseIcon && (
                          <XIcon
                            className={`${
                              !isDarkPage
                                ? "text-gray-800 hover:text-gray-700"
                                : "text-neutral-400 hover:text-neutral-700"
                            } cursor-pointer w-4 h-4 absolute top-3 right-3 transition-all duration-200`}
                            size={14}
                            onClick={() => {
                              setOpen(false);
                              onCloseIconClick && onCloseIconClick();
                            }}
                          />
                        )}
                      </div>
                    </Modal.Title>
                  </Modal.Header>
                )}
                {showDivider && (
                  <div
                    className={`h-0.5 w-full border-t ${
                      !isDarkPage
                        ? "border-neutral-200"
                        : "border-neutral-800/70"
                    } mb-3`}
                  />
                )}
                <div className="flex-col flex sm:flex sm:items-start w-full 2xl:max-h-[80vh] max-h-[70vh] overflow-y-auto overflow-x-hidden px-2">
                  {component({
                    _close: () => setOpen(false),
                    ...componentProps
                  })}
                </div>
              </div>
            </div>
          </Draggable>
        </div>
      </div>
    </div>
  );
}
